const baseURL = process.env.NODE_ENV === 'production' ? 'https://admintesting.credifin.com.ar' : 'http://localhost:9000';
const autogestionURL = process.env.NODE_ENV === 'production' ? 'https://credifin.com.ar/autogestion' : 'http://localhost:3000';
const autogestionFrontendURL = process.env.NODE_ENV === 'production' ? 'https://credifin.com.ar' : 'http://localhost:4000';
const poolURL = process.env.NODE_ENV === 'production' ? 'https://admintesting.credifin.com.ar/pool' : 'http://localhost:9003';
const credifinImpresorasURL = process.env.NODE_ENV === 'production' ? 'http://localhost:9000' : 'http://localhost:9011';    // asegurarse de cambiar puerto de printerPool

export const config = {
    URL_API_PRIVATE: `${baseURL}/api`,
    URL_API_PUBLIC: `${baseURL}/api/public`,
    URL_STATIC: `${baseURL}/static`,
    URL_SOCKET: 'https://admintesting.credifin.com.ar/socket',
    URL_AGILDATA: 'https://panel.agildataonline.com/api/v1',
    URL_API_STOCK: 'https://api.stockdistribuciones.com.ar/api',
    URL_AZURE_STORAGE: 'https://admintesting.credifin.com.ar/storage',
    URL_POOL: `${poolURL}/api`,
    URL_PRINTER_POOL: `${credifinImpresorasURL}/api`,
    URL_IMPRESORAS_CONFIG: `${credifinImpresorasURL}/config/impresoras`,
    URL_AUTOGESTION: autogestionURL,
    URL_AUTOGESTION_FRONTEND: autogestionFrontendURL,
};